import React, { useEffect, useMemo, useState } from "react";
import ReusableTable from "../../components/Employee/Table";
import { useGetAllEmployeesPaginated } from "../../hooks/useUsers";
import { getMediaBase64 } from "../../util/common";

function MyTeamLayout() {
  const [pageCount, setPageCount] = useState(1);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [teamRecords, setTeamRecords] = useState([]);

  const employees = useGetAllEmployeesPaginated();

  const fetchEmployeeRecords = async () => {
    employees.mutate(
      {
        page: pagination.page,
        pageSize: pagination.pageSize,
      },
      {
        onSuccess: async (result) => {
          if (!result.success) return;
          const records = await Promise.all(
            result.data.data.map(async (record) => {
              const employeeCurrentDepartment = record.DepartmentRecords?.find(
                (d) => d.Current
              );
              return {
                Media: await getMediaBase64(
                  record?.ProfilePictureMedia?.MediaUrl
                ),
                Name: record.FullName,
                Department: employeeCurrentDepartment?.Department?.Name,
              };
            })
          );

          setTeamRecords(records);
          setPageCount(result.data.pagination.totalPages);
        },
      }
    );
  };

  useEffect(() => {
    fetchEmployeeRecords();
  }, [pagination]);

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "Name",
        header: "Employee",
        cell: ({ row }) => {
          const media = row.original.Media;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <img
                src={media}
                alt="Profile"
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
                onError={(e) => (e.target.style.display = "none")}
              />
              <span>{row.original.Name}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "Department",
        header: "Department",
      },
    ],
    []
  );

  return (
    <>
      <div className="team-container">
        <div className="header-row">
          <h3>My Team</h3>
        </div>
        <ReusableTable
          data={teamRecords}
          columns={columns}
          mode="server"
          initialPageSize={pagination.pageSize}
          onPageChange={handleOnPageChange}
          pageCount={pageCount}
          page={pagination.page - 1}
          pageSize={pagination.pageSize}
        />
      </div>
    </>
  );
}

export default MyTeamLayout;
